/* Wishlist MVP */
import { Utils } from "@scripts/components/functions.js";

export const Wishlist = (function(){
  return {
    state: false,
    elements: {
      back: null,
      toggler: null,
      counter: null,
      sidebar: null,
      list   : null,
      overlay: null,
    },
    init: function(){
      this.storagePrefix = '_ez_wishlist';
      this.storageKey = this.storagePrefix + String(window._EZQR_SETTINGS.blog_id ?? '_N');
      this.storage = localStorage.getItem(this.storageKey) ? JSON.parse( localStorage.getItem(this.storageKey) ) : {};
      this.itemBtnClass = 'ez-wish';
      return this;
    },
    start: function(){
      this.setElements();

      if (this.state) {
        this.setListeners();
        this.update();
      }
      return this;
    },
    setElements: function(){
      // floating wishlist button
      this.elements.toggler = document.querySelector('.btn--wishlist');
      this.elements.counter = (this.elements.toggler instanceof HTMLElement)
        ? this.elements.toggler.querySelector('span')
        : null;
      // wishlist sidebar
      this.elements.sidebar = document.querySelector('.wishlist');
      // wishlist items container
      this.elements.list = (this.elements.sidebar instanceof HTMLElement)
        ? this.elements.sidebar.querySelector('.wishlist__list')
        : null;
      // wishlist items container
      this.elements.back = (this.elements.sidebar instanceof HTMLElement)
        ? this.elements.sidebar.querySelector('.wishlist__controls button')
        : null;
      // global overlay 
      this.elements.overlay = document.querySelector('.nav-overlay');

      if (this.elements.toggler instanceof HTMLElement &&
          this.elements.counter instanceof HTMLElement &&
          this.elements.sidebar instanceof HTMLElement &&
          this.elements.list    instanceof HTMLElement &&
          this.elements.overlay instanceof HTMLElement &&
          this.elements.back instanceof HTMLElement ) {
        this.state = true
      } else {
        console.debug('W:Components not found')
        console.debug('%o, %o, %o, %o, %o', this.elements.toggler,
          this.elements.counter,
          this.elements.sidebar,
          this.elements.list ,
          this.elements.overlay)
      }
      return this.state;
    },
    setListeners: function(){
      let that = this;
      if (this.state) {

        // hide wishbar if overlay clicked
        that.elements.overlay.addEventListener( 'click', function(){
            that.elements.sidebar.classList.remove('wishlist--toggled');
        }, true );
        
        that.elements.back.addEventListener( 'click', function(){
            that.elements.sidebar.classList.remove('wishlist--toggled');
        }, true );

        // recreate wishlist every time when toggler clicked
        that.elements.toggler.addEventListener( 'click', function() {
          // clear current list
          that.elements.list.innerHTML = '';
          
          // create elements from storage
          if (that.storage) {
            Object.keys(that.storage).forEach(id => {
              let itemElement = that.createItem(id);
              if (itemElement instanceof HTMLElement) {
                that.elements.list.appendChild(itemElement);
              }
            });
          } else {
            console.debug('W:Storage is empty')
          }

          // show wishbar
          that.elements.sidebar.classList.toggle('wishlist--toggled');
        } );

        // process click on item heart buttons
        document.querySelectorAll(`.${that.itemBtnClass}`).forEach(itemBtn => {
          itemBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            let id = e.currentTarget.dataset.id ?? '';
            if (id) {
              let isAlreadyAdded = that.storage[id] !== undefined ? true : false;
              if (isAlreadyAdded) {
                delete that.storage[id];
                document.querySelectorAll(`.${that.itemBtnClass}[data-id="${id}"]`).forEach(btn => {
                  btn.classList.remove(`${that.itemBtnClass}--active`);
                });
              } else {      
                that.storage[id] = {id};          
                document.querySelectorAll(`.${that.itemBtnClass}[data-id="${id}"]`).forEach(btn => {
                  btn.classList.add(`${that.itemBtnClass}--active`);
                });
              }

            }      
            // update every time when click heart btn on items
            that.update();
          })
        });

      } else {
        console.debug('W:Listeners not setted')
      }
    },
    update: function(){
      // update all wishlist buttons state
      Object.keys(this.storage).forEach(id => {
        document.querySelectorAll(`.${this.itemBtnClass}[data-id="${id}"]`).forEach(btn => {
          btn.classList.add(`${this.itemBtnClass}--active`);
        });
      });

      // update notifications state
      this.elements.counter.textContent = Object.keys(this.storage).length;
      this.elements.toggler.style.visibility = !Object.keys(this.storage).length ? 'hidden' : '';
      if ( !Object.keys(this.storage).length ) {
        this.elements.sidebar.classList.remove('wishlist--toggled');
      }

      // update wishlist storage state
      localStorage.setItem(this.storageKey, JSON.stringify(this.storage));
    },
    createItem: function(id) {
      const that = this;
      if ("content" in document.createElement("template")) {
        if ( id && window._WISHLISTING[id] !== undefined ) {
          // get data
          let storedImage = window._WISHLISTING[id]['img'] !== undefined
            ? window._WISHLISTING[id]['img']
            : '';
          let storedName = window._WISHLISTING[id]['name'] !== undefined
            ? window._WISHLISTING[id]['name']
            : '';
          // create element
          let template = document.getElementById("template-wishlist-item");
          let clone = template.content.cloneNode(true);

          let item = clone.querySelector('.wishlist__item'); 
          let img = clone.querySelector('.wishlist__item-image img');
          let name = clone.querySelector('.wishlist__item-name');
          let remover = clone.querySelector('.wishlist__remover');

          name.innerHTML = storedName;
          if (storedImage && img instanceof HTMLImageElement) {
            img.src = storedImage;
            img.setAttribute('src', storedImage);
          } else {
            img.remove();
          }

          /* Add navigation to element by click */
          item.addEventListener('click', function(){
            let validScrollTarget = null;
            document.querySelectorAll('.ez-wish[data-id="' + id + '"]').forEach(wishBtn => {
              if (!validScrollTarget && wishBtn.offsetParent !== null) { // check target button exists and visible
                validScrollTarget = wishBtn;
              }
            });
            if ( validScrollTarget ) {
              Utils.scrollToElement(validScrollTarget);
            } else {
              item.classList.add('inactive');
            }
          });

          /* Item remover */
          remover.addEventListener('click', (e)=> {
            e.stopPropagation(); // Prevent other events on click this
            item.remove();
            document.querySelectorAll('.ez-wish[data-id="' + id + '"]').forEach(wishItBtn => {
              wishItBtn.classList.remove('ez-wish--active');
            });
            delete that.storage[id];
            // update when click remove btn in wishlist
            that.update();
          });

          return item;

        } else {
          console.debug('W:Id %s not extists', id);
        }
      }
    }
  }
});
